import { createAction, createReducer } from "@reduxjs/toolkit";

export const addToDo = createAction("addToDo");
export const resetToDo = createAction("resetToDo");

let lastId = 0;

// Old Reducer Format
// export default function toDos(state = [], action) {
//   switch (action.type) {
//     case addToDo.type: {
//       console.log("Reducer Called");
//       return [
//         ...state,
//         { id: ++lastId, description: action.payload.description },
//       ];
//     }

//     default:
//       return state;
//   }
// }

const initialState = {
  task: [],
}

export default createReducer(initialState, {
  [addToDo.type]: (state, action) => {
    state.task.push({
        id: ++lastId,
        description: action.payload.description
    })
  },
  [resetToDo.type]: (state, action) => {
    state.task = [];
  }
});
